import { combineReducers } from 'redux';

const archived = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_ARCHIVE_QUESTIONS_FULFILLED':
      return action.payload.data.result;
    case 'FETCH_ARCHIVE_QUESTIONS_REJECTED':
      return [];
    default:
      return state;
  }
};

const totalCount = (state = 0, action) => {
  switch (action.type) {
    case 'FETCH_ARCHIVE_QUESTIONS_FULFILLED':
      return action.payload.data.totalCount;
    case 'FETCH_ARCHIVE_QUESTIONS_REJECTED':
      return 0;
    default:
      return state;
  }
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_ARCHIVE_QUESTIONS_PENDING':
      return true;
    case 'FETCH_ARCHIVE_QUESTIONS_REJECTED':
    case 'FETCH_ARCHIVE_QUESTIONS_FULFILLED':
      return false;
    default:
      return state;
  }
};

const archive = combineReducers({
  archived,
  totalCount,
  isFetching,
});

export default archive;
